import React, { useState, useEffect } from "react";
import pet, { ANIMALS } from "@frontendmasters/pet";
import useDropdown from "./useDropdown";
import "regenerator-runtime/runtime";
import Results from "./Results";
import axios from "axios";

const SearchParams = () => {
  let animalsToShow = ANIMALS.filter((animal) => {
    if (animal !== "cat") {
      return true;
    } else {
      return false;
    }
  });

  const [location, setLocation] = useState("Seattle, WA");
  const [animal, AnimalDropdown] = useDropdown("Animal", "dog", animalsToShow);
  const [breeds, setBreeds] = useState([]);
  const [breed, BreedDropdown, setBreed] = useDropdown("Breed", "", breeds);
  const [pets, setPets] = useState([]);

  async function requestPets() {
    // const { animals } = await pet.animals({
    //   location,
    //   breed,
    //   type: animal,
    // });
    // setPets(animals || []);
    // console.log(animals);

    axios
      .get(
        "https://m64rjnruz2.execute-api.us-east-1.amazonaws.com/dev/petapis/animals",
        {
          params: {
            animal,
            location,
            breed,
          },
        }
      )
      .then((resp) => resp.data)
      .then((data) => setPets(data["animals"]));
  }

  useEffect(() => {
    setBreeds([]);
    setBreed("");
    console.log("effect reached");
    const breedURL = `https://m64rjnruz2.execute-api.us-east-1.amazonaws.com/dev/petapis/breeds?animal=${animal}`;
    axios.get(breedURL).then((resp) => {
      const breeds = resp.data.breeds;
      console.log("Data is : ", breeds);
      setBreeds(breeds.map((breed) => breed.name));
    });
  }, [animal]);

  return (
    <div className="search-params">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          requestPets();
        }}
      >
        <label htmlFor="location">
          Location
          <input
            type="text"
            id="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </label>
        <AnimalDropdown />
        {/* Breed Dropbox */}
        <BreedDropdown />
        <button type="submit">Submit</button>
      </form>
      <Results pets={pets} />
    </div>
  );
};

export default SearchParams;
